import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "lg:max-w-5xl w-full grid gap-3 grid-cols-1 md:grid-cols-5 md:gap-x-5 lg:mx-auto" }
const _hoisted_2 = { class: "col-span-5 mt-5 sm:mt-0 mb-5" }
const _hoisted_3 = { "aria-label": "Progress" }
const _hoisted_4 = {
  role: "list",
  class: "space-y-4 md:flex md:space-y-0 md:space-x-8"
}
const _hoisted_5 = { class: "text-sm font-medium text-royal-blue-600 group-hover:text-royal-blue-800" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "text-sm font-medium text-royal-blue-600" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "text-sm font-medium text-gray-500 group-hover:text-gray-700" }
const _hoisted_10 = { class: "col-span-5 md:col-span-3" }
const _hoisted_11 = { class: "text-base font-semibold text-gray-900 mb-3" }
const _hoisted_12 = { class: "p-4" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_14 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = {
  key: 0,
  class: "h-8 w-auto sm:h-6 sm:shrink-0",
  viewBox: "0 0 36 24",
  "aria-hidden": "true"
}
const _hoisted_18 = {
  key: 1,
  class: "h-8 w-auto sm:h-6 sm:shrink-0",
  viewBox: "0 0 39 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_19 = { class: "mt-0 ml-3" }
const _hoisted_20 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_21 = { class: "mt-0 sm:ml-6 shrink-0 flex items-center" }
const _hoisted_22 = ["id", "aria-describedby", "value"]
const _hoisted_23 = { class: "mt-3" }
const _hoisted_24 = {
  for: `card-other`,
  class: "rounded-md bg-gray-100 px-3 py-2.5 flex items-center justify-between cursor-pointer"
}
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_27 = { class: "mt-0 sm:ml-6 shrink-0 flex items-center" }
const _hoisted_28 = {
  key: 2,
  class: "mt-5 text-sm text-gray-700"
}
const _hoisted_29 = { class: "font-medium" }
const _hoisted_30 = {
  key: 3,
  class: "mt-5 text-sm text-gray-700"
}
const _hoisted_31 = { class: "font-medium" }
const _hoisted_32 = {
  key: 4,
  class: "mt-3 text-sm text-gray-500"
}
const _hoisted_33 = { class: "font-medium" }
const _hoisted_34 = { class: "mt-3 text-sm text-gray-500" }
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 0,
  class: "col-span-5 md:col-span-2"
}
const _hoisted_37 = { class: "text-base font-semibold text-gray-900 mb-3" }
const _hoisted_38 = {
  class: /*@__PURE__*/_normalizeClass(['relative block rounded-md bg-white p-4 shadow-xs focus:outline-hidden flex justify-between items-start'])
}
const _hoisted_39 = { class: "flex items-center" }
const _hoisted_40 = { class: "flex flex-col text-sm" }
const _hoisted_41 = { class: "font-medium text-gray-900" }
const _hoisted_42 = { class: "text-gray-500 flex flex-col" }
const _hoisted_43 = { class: "block sm:inline" }
const _hoisted_44 = {
  key: 0,
  class: "block sm:inline"
}
const _hoisted_45 = {
  key: 1,
  class: "block sm:inline"
}
const _hoisted_46 = {
  key: 2,
  class: "block sm:inline"
}
const _hoisted_47 = {
  key: 3,
  class: "block sm:inline"
}
const _hoisted_48 = { class: "flex text-sm sm:mt-0 sm:ml-4 flex-col sm:justify-center sm:text-right" }
const _hoisted_49 = { class: "font-medium text-gray-900" }
const _hoisted_50 = { class: "sm:ml-1 text-gray-500 sm:ml-0" }
const _hoisted_51 = {
  key: 0,
  class: "border-l-4 border-red-400 bg-red-50 p-4 mt-3"
}
const _hoisted_52 = { class: "flex" }
const _hoisted_53 = { class: "shrink-0" }
const _hoisted_54 = { class: "ml-3" }
const _hoisted_55 = { class: "text-sm text-red-700" }
const _hoisted_56 = { class: "bg-white rounded-md shadow-xs p-4 text-sm" }
const _hoisted_57 = { class: "font-medium text-gray-900" }
const _hoisted_58 = { class: "mt-2 flex" }
const _hoisted_59 = { class: "-mr-px grid grow grid-cols-1 focus-within:relative" }
const _hoisted_60 = ["placeholder"]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_63 = { class: "bg-white rounded-md shadow-xs p-4 text-sm" }
const _hoisted_64 = { class: "font-medium text-gray-900" }
const _hoisted_65 = { class: "my-2 text-gray-500" }
const _hoisted_66 = {
  key: 3,
  class: "border-l-4 border-blue-400 bg-blue-50 p-4 mt-3"
}
const _hoisted_67 = { class: "flex" }
const _hoisted_68 = { class: "ml-3" }
const _hoisted_69 = { class: "text-sm text-blue-700" }
const _hoisted_70 = {
  key: 4,
  class: "border-l-4 border-purple-500 bg-gradient-to-r from-purple-50 to-pink-50 p-4 mt-3"
}
const _hoisted_71 = { class: "flex" }
const _hoisted_72 = { class: "ml-3 flex-1" }
const _hoisted_73 = { class: "text-sm font-bold text-purple-900" }
const _hoisted_74 = ["innerHTML"]
const _hoisted_75 = ["href"]
const _hoisted_76 = { class: "mt-3" }
const _hoisted_77 = { class: "flex items-center justify-between lg:px-4 text-sm" }
const _hoisted_78 = { class: "font-medium text-gray-900" }
const _hoisted_79 = { class: "text-gray-500" }
const _hoisted_80 = {
  key: 0,
  class: "me-2"
}
const _hoisted_81 = { class: "text-gray-900" }
const _hoisted_82 = { class: "mt-3" }
const _hoisted_83 = {
  key: 0,
  class: "loader"
}
const _hoisted_84 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ol", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
            return (_openBlock(), _createElementBlock("li", {
              key: step.name,
              class: "md:flex-1"
            }, [
              (step.status === 'complete')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: step.href,
                    class: "group flex flex-col border-l-4 border-royal-blue-600 py-2 pl-4 hover:border-royal-blue-800 md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(step.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (step.status === 'current')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: step.href,
                      class: "flex flex-col border-l-4 border-royal-blue-600 py-2 pl-4 md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0",
                      "aria-current": "step"
                    }, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(step.name), 1)
                    ], 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: step.href,
                      class: "group flex flex-col border-l-4 border-gray-200 py-2 pl-4 hover:border-gray-300 md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0"
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(step.name), 1)
                    ], 8, _hoisted_8))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('checkout.payment_info')), 1),
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
        class: "bg-white rounded-md shadow-xs"
      }, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.wallet.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.$t('checkout.wallet_empty_1')) + " " + _toDisplayString(_ctx.$t('checkout.wallet_empty_2')) + " ", 1),
                _createVNode(_component_router_link, {
                  class: "text-royal-blue-500",
                  to: "/subscription"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('checkout.wallet_empty_3')), 1)
                  ]),
                  _: 1
                }),
                _cache[7] || (_cache[7] = _createTextVNode(". "))
              ]))
            : _createCommentVNode("", true),
          (_ctx.wallet.length !== 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('checkout.wallet_tip')), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallet, (walletItem, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-3",
              key: `wallet-item-${index}-${walletItem.key}`
            }, [
              _createElementVNode("label", {
                for: `card-${walletItem.key}`,
                class: "rounded-md bg-gray-100 px-3 py-2.5 flex items-center justify-between cursor-pointer"
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sr-only" }, "Visa", -1)),
                _createElementVNode("span", _hoisted_16, [
                  (walletItem.payment_system === 'visa')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[8] || (_cache[8] = [
                        _createElementVNode("rect", {
                          width: "36",
                          height: "24",
                          fill: "#224DBA",
                          rx: "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          fill: "#fff",
                          d: "M10.925 15.673H8.874l-1.538-6c-.073-.276-.228-.52-.456-.635A6.575 6.575 0 005 8.403v-.231h3.304c.456 0 .798.347.855.75l.798 4.328 2.05-5.078h1.994l-3.076 7.5zm4.216 0h-1.937L14.8 8.172h1.937l-1.595 7.5zm4.101-5.422c.057-.404.399-.635.798-.635a3.54 3.54 0 011.88.346l.342-1.615A4.808 4.808 0 0020.496 8c-1.88 0-3.248 1.039-3.248 2.481 0 1.097.969 1.673 1.653 2.02.74.346 1.025.577.968.923 0 .519-.57.75-1.139.75a4.795 4.795 0 01-1.994-.462l-.342 1.616a5.48 5.48 0 002.108.404c2.108.057 3.418-.981 3.418-2.539 0-1.962-2.678-2.077-2.678-2.942zm9.457 5.422L27.16 8.172h-1.652a.858.858 0 00-.798.577l-2.848 6.924h1.994l.398-1.096h2.45l.228 1.096h1.766zm-2.905-5.482l.57 2.827h-1.596l1.026-2.827z"
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  (walletItem.payment_system === 'mc')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[9] || (_cache[9] = [
                        _createElementVNode("path", {
                          d: "M38.6082 19.386V18.9218H38.4868L38.3465 19.2406L38.2068 18.9218H38.0847V19.386H38.171V19.0359L38.3022 19.338H38.3915L38.5227 19.0352V19.386H38.6082ZM37.8383 19.386V19.0009H37.9939V18.9225H37.5972V19.0009H37.7528V19.386H37.8383Z",
                          fill: "#F79410"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M24.8127 21.3828H14.3124V2.56079H24.8127V21.3828Z",
                          fill: "#FF5F00"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M14.9852 11.9703C14.9852 8.15215 16.7775 4.75106 19.5686 2.55927C17.5275 0.95652 14.9516 -0.000104904 12.1521 -0.000104904C5.52451 -0.000104904 0.1521 5.35913 0.1521 11.9703C0.1521 18.5814 5.52451 23.9407 12.1521 23.9407C14.9516 23.9407 17.5275 22.984 19.5686 21.3813C16.7775 19.1895 14.9852 15.7884 14.9852 11.9703Z",
                          fill: "#EB001B"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M38.9744 11.9703C38.9744 18.5814 33.602 23.9407 26.9744 23.9407C24.1749 23.9407 21.599 22.984 19.5571 21.3813C22.349 19.1895 24.1413 15.7884 24.1413 11.9703C24.1413 8.15216 22.349 4.75107 19.5571 2.55928C21.599 0.95653 24.1749 -9.53674e-05 26.9744 -9.53674e-05C33.602 -9.53674e-05 38.9744 5.35914 38.9744 11.9703Z",
                          fill: "#F79E1B"
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(walletItem.pan), 1)
                  ])
                ]),
                _createElementVNode("span", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    id: `card-${walletItem.key}`,
                    "aria-describedby": `card-${walletItem.key}-description`,
                    name: "card",
                    type: "radio",
                    value: walletItem.key,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.card) = $event)),
                    class: "relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-royal-blue-600 checked:bg-royal-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden"
                  }, null, 8, _hoisted_22), [
                    [_vModelRadio, _ctx.card]
                  ])
                ])
              ], 8, _hoisted_15)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('checkout.other_card')), 1)
              ]),
              _createElementVNode("span", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  id: `card-other`,
                  "aria-describedby": `card-other-description`,
                  name: "card",
                  type: "radio",
                  value: "other",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.card) = $event)),
                  class: "relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-royal-blue-600 checked:bg-royal-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden"
                }, null, 512), [
                  [_vModelRadio, _ctx.card]
                ])
              ])
            ])
          ]),
          ((_ctx.user && _ctx.user.subscription_type) === 'free' || (_ctx.user && _ctx.selectedPlan && _ctx.user.subscription_type !== _ctx.selectedPlan.key))
            ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('checkout.payment_tip_1', {date: _ctx.next_payment})), 1)
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('checkout.payment_tip_2')), 1)
              ])),
          (_ctx.selectedPlan && _ctx.selectedPlan.price === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('checkout.payment_tip_3')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_34, [
            _createTextVNode(_toDisplayString(_ctx.$t('checkout.agreement_1')) + " ", 1),
            _createElementVNode("a", {
              href: _ctx.publicUrl('agreement'),
              target: "_blank",
              class: "text-royal-blue-500"
            }, _toDisplayString(_ctx.$t('checkout.agreement_2')), 9, _hoisted_35),
            _createTextVNode(". " + _toDisplayString(_ctx.$t('checkout.agreement_3')) + " " + _toDisplayString(_ctx.$t('checkout.agreement_4')) + " ", 1),
            _createVNode(_component_router_link, {
              class: "text-royal-blue-500",
              to: "/subscription"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('checkout.agreement_5')), 1)
              ]),
              _: 1
            }),
            _cache[11] || (_cache[11] = _createTextVNode(". "))
          ])
        ])
      ], 32)
    ]),
    (_ctx.selectedPlan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.$t('checkout.subscription_details')), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("span", _hoisted_39, [
              _createElementVNode("span", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.selectedPlan.title), 1),
                _createElementVNode("span", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(Math.round(_ctx.selectedPlan.limit / (1024 * 1024 * 1024) * 100) / 100) + " " + _toDisplayString(_ctx.$t('subscription_plan.gb_storage')), 1),
                  (_ctx.selectedPlan.key !== 'free')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('subscription_plan.up_to_video')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedPlan.key !== 'free')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t('subscription_plan.unlimited_storage')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedPlan.features && _ctx.selectedPlan.features.face_recognition)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, "✨ " + _toDisplayString(_ctx.$t('subscription_plan.face_recognition')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedPlan.key === 'free')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t('subscription_plan.gallery_storage_60_days')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("span", _hoisted_48, [
              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.formatPriceWithDecimals((_ctx.totalPrice / _ctx.selectedPeriod) / 100)) + " " + _toDisplayString(_ctx.getCurrencySymbol()), 1),
              _createElementVNode("span", _hoisted_50, "/ " + _toDisplayString(_ctx.$t('checkout.month')), 1)
            ])
          ]),
          (_ctx.promo_error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_XCircleIcon, {
                      class: "size-5 text-red-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.promo_error.message), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.promo_info === null)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.usePromo && _ctx.usePromo(...args)), ["prevent"])),
                class: "mt-3"
              }, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('checkout.promocode')), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.promo) = $event)),
                          name: "code",
                          class: "col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pr-3 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:pl-3 sm:text-sm/6",
                          placeholder: _ctx.$t('checkout.enter_promo')
                        }, null, 8, _hoisted_60), [
                          [_vModelText, _ctx.promo]
                        ])
                      ]),
                      _createElementVNode("button", {
                        disabled: _ctx.promo === null || _ctx.promo === '',
                        type: "submit",
                        class: "flex shrink-0 items-center gap-x-1.5 rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 outline-1 -outline-offset-1 outline-gray-300 hover:bg-gray-50 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 cursor-pointer"
                      }, _toDisplayString(_ctx.$t('checkout.use_promo')), 9, _hoisted_61)
                    ])
                  ])
                ])
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.promo_info !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t('checkout.promocode')) + " \"" + _toDisplayString(_ctx.promo_info.title) + "\" " + _toDisplayString(_ctx.$t('checkout.promo_gives')) + ":", 1),
                  _createElementVNode("ul", _hoisted_65, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promo_info.preferences_titles, (preference, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `preference-promo-item-${index}`
                      }, _toDisplayString(preference), 1))
                    }), 128))
                  ]),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removePromo && _ctx.removePromo(...args)), ["prevent"])),
                    class: "text-red-700"
                  }, _toDisplayString(_ctx.$t('checkout.delete_promo')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currencyPrice && _ctx.currencyRate && _ctx.currencyRate !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "size-5 text-blue-400",
                      fill: "currentColor",
                      viewBox: "0 0 20 20",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.$t('checkout.currency_notification', {
                                uahPrice: (_ctx.currencyPrice / 100).toFixed(2),
                                rate: _ctx.currencyRate.toFixed(2)
                            })), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.blackFridayUpgrade && _ctx.blackFridayUpgrade.is_active)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "shrink-0" }, [
                    _createElementVNode("span", { class: "text-2xl" }, "🛍️")
                  ], -1)),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("p", _hoisted_73, " ⚡ " + _toDisplayString(_ctx.$t('subscription.black_friday.checkout_title')), 1),
                    _createElementVNode("p", {
                      class: "text-sm text-purple-800 mt-1",
                      innerHTML: _ctx.$t('subscription.black_friday.checkout_description', {
                            discount: _ctx.blackFridayUpgrade.discount_percent,
                            bonusDays: _ctx.blackFridayUpgrade.bonus_days
                        })
                    }, null, 8, _hoisted_74),
                    _createElementVNode("a", {
                      href: _ctx.blackFridayTermsUrl,
                      target: "_blank",
                      class: "ml-2 text-sm font-medium text-purple-700 hover:text-purple-900 hover:underline transition-all cursor-pointer"
                    }, _toDisplayString(_ctx.$t('subscription.black_friday.terms_button')), 9, _hoisted_75)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('checkout.total_amount')), 1),
              _createElementVNode("span", _hoisted_79, [
                (_ctx.oldPrice !== 0 && _ctx.oldPrice !== null && _ctx.totalPrice != _ctx.oldPrice)
                  ? (_openBlock(), _createElementBlock("s", _hoisted_80, _toDisplayString(_ctx.formatPriceWithDecimals(_ctx.oldPrice / 100)) + " " + _toDisplayString(_ctx.getCurrencySymbol()), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.formatPriceWithDecimals(_ctx.totalPrice / 100)) + " " + _toDisplayString(_ctx.getCurrencySymbol()), 1),
                _createTextVNode("/ " + _toDisplayString(_ctx.periodTitle), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
              class: "cursor-pointer w-full inline-flex justify-center rounded-md border border-transparent bg-royal-blue-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-royal-blue-700 focus:outline-none focus:ring-2 focus:ring-royal-blue-500 focus:ring-offset-2"
            }, [
              (_ctx.isLoadingCheckout)
                ? (_openBlock(), _createElementBlock("span", _hoisted_83))
                : (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.$t('checkout.pay')), 1))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}